import React, {Component} from 'react';
import NavBar from 'components/NavBar';

class AdminPanel extends Component {
  render() {
    return (
      <div>
        <NavBar />
        {this.props.children}
      </div>
    )
  }
}

export default AdminPanel;


// WEBPACK FOOTER //
// ./src/components/AdminPanel.js